export type ReportRetrieveMethod = number;
export const ReportRetrieveMethodUnknown: ReportRetrieveMethod = 0;
export const ReportRetrieveMethodPreview: ReportRetrieveMethod = 1;
export const ReportRetrieveMethodDownload: ReportRetrieveMethod = 2;
export const ReportRetrieveMethodEmail: ReportRetrieveMethod = 3;
export const ReportRetrieveMethodSchedule: ReportRetrieveMethod = 4;
